 (function() {
     var header = document.querySelector('.header-section');
     var nav = document.querySelector('nav.mobile-dock');
     if (!header || !nav) return;

     var navHeight = nav.offsetHeight;
     var bubbleOffsetBase = null;
     var previewOffsetBase = null;
     var mobileQuery = window.matchMedia('(max-width: 767px)');

     function adjustBubble() {
         if (!mobileQuery.matches) return;

         var host = document.querySelector('#zipchat-shadow-host');
         var bubble = host?.shadowRoot?.querySelector('#widget-chat-container');
         var preview = host?.shadowRoot?.querySelector('#chat-preview-message');

         if (!bubble) return;

         if (bubbleOffsetBase === null) {
             bubbleOffsetBase = parseInt(bubble.style.bottom, 10);
         }
         if (preview && previewOffsetBase === null) {
             previewOffsetBase = parseInt(preview.style.bottom, 10);
             preview.style.transition = 'bottom 0.2s ease-in-out';
         }

         var dockVisible = header.classList.contains('header-hidden');
         var stickyForm = document.querySelector('.product-sticky-form');
         var stickyFormVisible = stickyForm && window.getComputedStyle(stickyForm.querySelector('.product-sticky-form__card')).visibility === 'visible';
         var stickyFormHeight = stickyFormVisible ? stickyForm.offsetHeight : 0;

         var offset = 0;
         if (dockVisible) offset += navHeight;
         if (stickyFormVisible) offset += stickyFormHeight;

         bubble.style.setProperty('bottom', (offset + bubbleOffsetBase) + 'px', 'important');
         if (preview) {
             preview.style.setProperty('bottom', (offset + previewOffsetBase) + 'px', 'important');
         }
     }

     new MutationObserver(adjustBubble).observe(header, {
         attributes: true,
         attributeFilter: ['class']
     });

     // Also watch for the sticky form appearing/disappearing                                                                                                                                                                                                                                
     var stickyForm = document.querySelector('.product-sticky-form');
     if (stickyForm) {
         new MutationObserver(adjustBubble).observe(stickyForm, {
             attributes: true,
             subtree: true,
             attributeFilter: ['style', 'class']
         });
     }

     adjustBubble();
 })();